import React, { useState } from 'react';
import { Box, MenuItem, Text, config } from 'folds';
import { RoleInviteList } from './RoleInviteList';
import personLogo from '../../../../public/icon/新增真人按鈕.png';

type InviteRole = {
  role: string;
  label: string;
  icon: string;
};

export const INVITE_ROLES: InviteRole[] = [
  { role: 'CS', label: '客服', icon: personLogo },
  { role: 'PM', label: 'PM', icon: personLogo },
];

type InviteRoleContentProps = {
  roomId: string;
};

export function InviteRoleContent({ roomId }: InviteRoleContentProps) {
  const [selectedRole, setSelectedRole] = useState<string | null>(null);

  return (
    <Box direction="Column" style={{ padding: config.space.S200 }}>
      {INVITE_ROLES.map(({ role, label, icon }) => (
        <Box key={role} direction="Column">
          <MenuItem
            size="400"
            radii="300"
            variant="Surface"
            aria-pressed={selectedRole === role}
            onClick={() => setSelectedRole(selectedRole === role ? null : role)}
            before={
              <img src={icon} style={{ width: '24px', height: '24px' }} alt={label} />
            }
          >
            <Text size="T300" style={{ fontWeight: 500 }}>{label}</Text>
          </MenuItem>
          {selectedRole === role && (
            <Box style={{ paddingLeft: config.space.S400, paddingBottom: config.space.S100 }}>
              <RoleInviteList sroomid={roomId} role={role} />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}
